export const LAST_REACT_STOREFRONT_PAGE = 'lastReactStorefrontPage';
export const REACT_STOREFRONT_HISTORY = 'reactStorefrontHistory';
export const MAX_STOREFRONT_HISTORY_LENGTH = 50;
export const CHECKOUT_REMAINING_STEPS = 'checkoutRemainingSteps';
export const LAST_APP_DOWNLOAD_MOTIVATOR_VIEWED =
    'lastAppDownloadMotivatorViewed';
